import { OnInit, Input, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-button-view-form-dynamic',
  template: '<p>{{ dateString }}</p>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class CalendarRefactoryTableDynamicComponent implements ViewCell, OnInit {
  // entrada del valor del label
  @Input() value: any;
  // entrada de la fila
  @Input() rowData: any;
  // fecha a mostrar
  dateString = '';
  // Fecha
  date: Date;

  ngOnInit() {
    if (this.value) {
      this.date = new Date(this.value);
      this.dateString = this.date.toLocaleDateString();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/date-refactory/calendar-refactory-table-dynamic.component.ts